import React from 'react';
import { Avatar } from "primereact/avatar";

export const UserAvatar = (props) => {
    let style = props.style ? props.style : {};
    style['borderRadius'] = "50px";
    return (
        <Avatar
            label={props.label}
            icon={props.icon}
            image={props.image}
            size={props.size ? props.size : "small"}
            className={props.className}
            shape={props.shape ? props.shape : "circle"}
            style={style} />
    );
}